import Button from '../../../components/Buttons/Button';
import cn from '../../../lib/classNames';

import styles from './TravelRiskIntelligence.module.scss';

type TravelRiskIntelligenceType = {
	classPageContent?: string;
};

export default function TravelRiskIntelligence(props: TravelRiskIntelligenceType) {
	const { classPageContent } = props;
	return (
		<div className={styles.wrap}>
			<div className={cn(styles.content, classPageContent)}>
				<h3 className={styles.title}>Travel Risk Intelligence Fair Pricing</h3>
				<div className={styles.description}>
					Our affordable subscription model makes enterprise-quality travel risk intelligence
					accessible to organizations of all sizes. No more overpaying for generic intelligence.
				</div>
				<div className={styles['button-wrap']}>
					<Button
						className={cn(styles.button, 'button-book-the-demo')}
						elementType="button"
						variant="filled"
						color="secondary"
						size="large"
						// Disabled due to the Ortto form usage
						// elementType="link"
						// href="https://safe-esteem.typeform.com/to/UVWEowBk"
						// target="_blank"
					>
						Get Started Today
					</Button>
				</div>
			</div>
		</div>
	);
}
